export const SAVE = 'stepPersonalItems.SAVE';
export const VALUE_CHANGED = 'stepPersonalItems.VALUE_CHANGED';
export const LOAD = 'stepPersonalItems.VALUE_LOAD';
export const NEXT = 'stepPersonalItems.NEXT';
export const RESET = 'stepPersonalItems.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'stepPersonalItems.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'stepPersonalItems.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'stepPersonalItems.RESET_COMPENSATION';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPersonalItems/constants.js